export const SET_LANGUAGE_LIST = 'SET_LANGUAGE_LIST';


export const setLanguages = (languageArr) => {
    return {
        type: SET_LANGUAGE_LIST,
        payload: languageArr
    }
}